import React from 'react'
import {connect} from 'react-redux'
import ErrorMessage from './ErrorMessage'
import {filterHTML} from "../../utils"

import '../../styles/messages/VideoMessage.css'


class VideoMessage extends React.PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            visible: Boolean(props.message.status)
        }
    }

    componentDidMount() {
        const {message} = this.props
        if (!this.state.visible) {
            this.context.classroomPage.lazyLoads.push({
                el: document.getElementById('message_' + message.id),
                onVisible: () => this.setState({visible: true})
            })
        }
    }

    play(e) {
        const {message} = this.props
        if (message.type === 'iframe') {
            let dataUrl = window.systemType === 'ios' ? message.meta.src : e.target.children[0].src
            if (dataUrl.indexOf('http://v.qq.com/') > -1) {
                dataUrl = dataUrl.replace('http://v.qq.com/', 'https://v.qq.com/')
            }
            this.props.dispatch({
                type: 'SHOW_VIDEO_PLAYER',
                payload: {
                    dataUrl: dataUrl,
                    type: 'iframe'
                }
            })
        } else {
            let v = JSON.parse(message.content)
            this.props.dispatch({
                type: 'SHOW_VIDEO_PLAYER',
                payload: {
                    dataUrl: v.video_url,
                    type: 'video'
                }
            })
        }
    }

    renderContent() {
        const {message} = this.props
        if (message.type === 'iframe') {
            if (window.systemType === 'ios') {
                return <div className="iframe-preview" onClick={this.play.bind(this)}>
                    <span className="play-btn"><i className="iconfont icon-bofang-copy"/></span>
                </div>
            } else {
                let content = message.content
                if (content.indexOf('http://v.qq.com/') > -1) {
                    content = content.replace('http://v.qq.com/', 'https://v.qq.com/')
                }
                return <div className="set-html" onClick={this.play.bind(this)} dangerouslySetInnerHTML={{__html: filterHTML(content)}}/>
            }
        } else {
            let v = JSON.parse(message.content)
            return <div className="preview2" onClick={this.play.bind(this)}>
                <img src={v.thumb_url} alt="preview"/>
                <span className="play-btn">
					<i className="iconfont icon-bofang-copy"></i>
				</span>
            </div>
        }
    }

    render() {
        try {
            return (
                <div className="video-content">
                    {this.state.visible &&
                    <div className="wrap-video">
                        {this.renderContent()}
                    </div>
                    }
                </div>
            )
        } catch(e) {
            return <ErrorMessage/>
        }
    }
}


VideoMessage.contextTypes = {
    classroomPage: React.PropTypes.object
};


export default connect()(VideoMessage)




// WEBPACK FOOTER //
// ./src/components/messages/VideoMessage.js